import { Clock } from 'lucide-react';

export default function OrderInfoCard({ order, exchangeRate }) {
  return (
    <div className="bg-white rounded-2xl shadow-2xl p-6 mb-6" data-testid="payment-order-info">
      <div className="flex items-start justify-between mb-6">
        <div>
          <h2 className="text-xl font-bold mb-1" style={{ color: '#051C2C' }}>{order.description}</h2>
          <p className="text-sm text-gray-600">
            Código: <span className="font-mono font-bold">{order.order_code}</span>
          </p>
        </div>
        <div className="text-right">
          <p className="text-sm text-gray-600">Monto a Pagar</p>
          <p className="text-3xl font-bold" style={{ color: '#003594' }}>
            {order.currency} {order.amount.toFixed(2)}
          </p>
          {exchangeRate?.usd_ves && (
            <p className="text-xs text-gray-400 mt-1">
              Ref: ~${(order.amount / exchangeRate.usd_ves).toFixed(2)} USD (Tasa {exchangeRate.source}: Bs.{' '}
              {exchangeRate.usd_ves.toFixed(2)})
            </p>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 pt-4 border-t border-gray-200">
        <div>
          <p className="text-xs text-gray-600 mb-1">Cliente</p>
          <p className="text-sm font-medium">{order.payer_name}</p>
        </div>
        <div>
          <p className="text-xs text-gray-600 mb-1">Email</p>
          <p className="text-sm font-medium">{order.payer_email}</p>
        </div>
      </div>

      {order.expires_at && (
        <div className="mt-4 flex items-center gap-2 text-sm text-gray-600 bg-yellow-50 p-3 rounded-lg">
          <Clock className="w-4 h-4" />
          <span>
            Expira:{' '}
            {new Date(order.expires_at).toLocaleString('es-VE', {
              timeZone: 'America/Caracas',
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            })}
          </span>
        </div>
      )}
    </div>
  );
}
